<ng-container
              *ngIf="{
  coreDiners: assignedResidents$ | async,
  filteredDiners: diners$ | async
} as vm">
  <ion-header>
    <ion-toolbar mode="md" color="dark">
      <ion-title>
        <ng-container *ngIf="isServiceAppointment; else notServiceAppointment">{{'dining.assignClient' |
          transloco}}</ng-container>
      </ion-title>
      <ion-buttons slot="end">
        <ion-button
                    mode="md"
                    [disabled]="isSelectedTicketProcessing"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onCloseModal(true)">{{'common.close' | transloco}}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content fullscreen>
    <div class="diner-assignment">
      <div
           class="diner-assignment__tabs"
           *ngIf="(totalAssignedDiners !== 0 || visitingFacilities?.length !== 0) && (isDiningRoom || visitingFacilities?.length)">
        <div
             *ngIf="totalAssignedDiners > 0 && isDiningRoom"
             [class.active]="view === DINER_ASSIGNMENT_VIEW.PREASSIGNED"
             debounce-click
             [debounceTime]="0"
             (debounceClick)="onSetView(DINER_ASSIGNMENT_VIEW.PREASSIGNED)">
          <ion-icon name="people-circle-outline"></ion-icon>
          {{'dining.assignedToTable' | transloco}}
        </div>
        <div
             [class.active]="view === DINER_ASSIGNMENT_VIEW.LOOKUP"
             debounce-click
             [debounceTime]="0"
             (debounceClick)="onSetView(DINER_ASSIGNMENT_VIEW.LOOKUP)">
          <ion-icon name="people-outline"></ion-icon>
          {{visitingFacilities?.length ? ('dining.searchDiners' | transloco) :
          ('dining.otherDiners' | transloco)}}
        </div>
        <div
             *ngIf="visitingFacilities?.length"
             [class.active]="view === DINER_ASSIGNMENT_VIEW.OTHER_FACILITIES"
             debounce-click
             [debounceTime]="0"
             (debounceClick)="onSetView(DINER_ASSIGNMENT_VIEW.OTHER_FACILITIES)">
          <ion-icon name="business-outline"></ion-icon>
          {{'dining.otherFacilities' | transloco}}
        </div>
      </div>
      <div
           class="diner-assignment__filter"
           *ngIf="view === DINER_ASSIGNMENT_VIEW.LOOKUP || view === DINER_ASSIGNMENT_VIEW.OTHER_FACILITIES">
        <ion-select
                    translocoSelect
                    (ionChange)="onFacilityChange($event)"
                    [placeholder]="'dining.selectVisitingFacility' | transloco"
                    *ngIf="view === DINER_ASSIGNMENT_VIEW.OTHER_FACILITIES">
          <ion-select-option
                             *ngFor="let facility of visitingFacilities"
                             [value]="facility.facility_id">{{facility.facility_name}}</ion-select-option>
        </ion-select>
        <ion-input [autoFocusWithCondition]="view === DINER_ASSIGNMENT_VIEW.LOOKUP"
                   [placeholder]="'dining.searchDiner' | transloco"
                   min="2"
                   minlength="2"
                   debounce="500"
                   clearInput="true"
                   [value]="searchQuery"
                   [disabled]="view === DINER_ASSIGNMENT_VIEW.OTHER_FACILITIES && !visitingFacilityId"
                   (ionChange)="searchingDiners($event)"></ion-input>
        <small class="ion-text-start">{{'dining.minimumCharactersRequired' | transloco}}</small>
      </div>
      <!-- Diners to be updated when switching views-->
      <ion-list
                class="diner-assignment__list"
                *ngIf="!isSearchingDiner && !isLoading && (view === DINER_ASSIGNMENT_VIEW.PREASSIGNED ? vm.coreDiners : vm.filteredDiners) as diners">
        <ng-container
                      *ngIf="view === DINER_ASSIGNMENT_VIEW.PREASSIGNED && reservationDiners">
          <ng-container *ngIf="reservationDiners.length">
            <ion-list-header class="diner-assignment__sub-header ion-no-margin">
              <ion-label> {{'dining.reservations' | transloco}} </ion-label>
            </ion-list-header>

            <ion-item
                      button
                      *ngFor="let item of reservationDiners; index as index"
                      class="diner-assignment__diner"
                      (click)="onAssignDiner(item, index, false, true)">
              <ion-avatar slot="start">
                <pos-avatar-control></pos-avatar-control>
              </ion-avatar>
              <ion-label class="diner-assignment__diner__information">
                <h2><strong>{{item.diner_name}}</strong></h2>
                <span *ngIf="item.diner_id as dinerId"><strong>{{'dining.dinerId' | transloco}} </strong>
                  {{dinerId}}</span>
                <span *ngIf="item.live_location as liveLocation">
                  <strong>{{'dining.liveLocation' | transloco}}</strong>
                  {{liveLocation}}
                </span>
              </ion-label>
              <ion-button
                          *ngIf="{assigningButton: assigningReservation && assigningIndex === index} as condition"
                          mode="md"
                          color="dark"
                          [disabled]="condition.assigningButton">{{condition.assigningButton ? ('dining.assigning' |
                transloco)
                : ('dining.assign' | transloco)}}</ion-button>
            </ion-item>
          </ng-container>
        </ng-container>

        <ng-container
                      *ngIf="pendingAssignments && pendingAssignments.length > 0 && view === DINER_ASSIGNMENT_VIEW.PREASSIGNED">
          <ion-list-header class="diner-assignment__sub-header ion-no-margin">
            <ion-label> {{'dining.hostMode' | transloco}} </ion-label>
          </ion-list-header>
          <ion-item
                    button
                    *ngFor="let item of pendingAssignments; index as index"
                    class="diner-assignment__diner"
                    (click)="onAssignDiner(item, index, true)">
            <ion-avatar slot="start">
              <pos-avatar-control></pos-avatar-control>
            </ion-avatar>
            <ion-label class="diner-assignment__diner__information">
              <h2><strong>{{item.name}}</strong></h2>
              <span *ngIf="!item.guest"><strong>{{'dining.dinerId' | transloco}} </strong>
                {{item.diner_id}}</span>
            </ion-label>
            <ion-button
                        *ngIf="{assigningButton: assigningHostMode && assigningIndex === index} as condition"
                        mode="md"
                        color="dark"
                        [disabled]="condition.assigningButton">{{condition.assigningButton ? ('dining.assigning' |
              transloco) :
              ('dining.assign' | transloco)}}</ion-button>
          </ion-item>
        </ng-container>

        <ion-list-header
                         *ngIf="view === DINER_ASSIGNMENT_VIEW.PREASSIGNED && vm.coreDiners && vm.coreDiners.length > 0"
                         class="diner-assignment__sub-header ion-no-margin">
          <ion-label> {{'dining.core' | transloco}} </ion-label>
        </ion-list-header>

        <ion-item *ngFor="let diner of diners; index as index"
                  class="diner-assignment__diner"
                  [disabled]="isSelectedTicketProcessing"
                  (click)="onAssignDiner(diner, index)">
          <ion-avatar slot="start">
            <pos-avatar-control [value]="diner.photo"></pos-avatar-control>
          </ion-avatar>
          <ion-label class="diner-assignment__diner__information">
            <h2><strong>{{diner.first_name}} {{diner.last_name}}</strong></h2>
            <span><strong>{{'dining.id' | transloco}}</strong>
              {{diner.client_id}}</span>
            <span *ngIf="diner.type === 'resident'; else dinerInformation"><strong>{{'dining.liveLocation' |
                transloco}}</strong>
              {{diner.live_location}}</span>
            <ng-template #dinerInformation>
              <span><strong>{{'dining.category' | transloco}}</strong> {{
                diner.diner_category_name }}</span>
            </ng-template>
          </ion-label>

          <ion-button
                      *ngIf="{assigningButton: (!assigningHostMode && !assigningReservation) && assigningIndex === index} as condition"
                      mode="md"
                      color="dark"
                      [disabled]="condition.assigningButton">{{condition.assigningButton ? ('dining.assigning' |
            transloco) :
            ('dining.assign' | transloco)}}</ion-button>
        </ion-item>
        <ion-item
                  *ngIf="view === DINER_ASSIGNMENT_VIEW.PREASSIGNED && !diners?.length"
                  lines="none">
          <p>{{'dining.noDinersPreassigned' | transloco}}</p>
        </ion-item>
        <ion-item
                  *ngIf="(view === DINER_ASSIGNMENT_VIEW.LOOKUP || view === DINER_ASSIGNMENT_VIEW.OTHER_FACILITIES)
        && searchQuery && searchQuery.length > 2 && !diners?.length"
                  lines="none">
          <p>{{'dining.noDinersMatchCriteria' | transloco}}</p>
        </ion-item>
      </ion-list>
      <ion-list class="table-list__items" *ngIf="isLoading || isSearchingDiner">
        <pos-diner-assignment-skeleton></pos-diner-assignment-skeleton>
      </ion-list>
    </div>
  </ion-content>

  <!--Only if using Dining Room can assign Guest-->
  <ion-footer>
    <ion-toolbar mode="md" color="light">
      <ion-buttons slot="end">
        <ng-container *ngIf="ticket">
          <ion-button
                      *ngIf="isDiningRoom && ticket && !ticket.diner_id && !ticket.guest_of_diner_id"
                      mode="md"
                      color="dark"
                      fill="solid"
                      [disabled]="isSelectedTicketProcessing"
                      debounce-click
                      [debounceTime]="0"
                      (debounceClick)="onSeatGuestClicked()">{{'dining.seatGuest' | transloco}}</ion-button>
          <ion-button
                      *ngIf="ticket && (ticket.diner_id || ticket.guest_of_diner_id)"
                      mode="md"
                      color="danger"
                      fill="solid"
                      [disabled]="isSelectedTicketProcessing"
                      debounce-click
                      [debounceTime]="0"
                      (debounceClick)="onRemoveDiner(ticket.guest_of_diner_id ? true : false)">{{
            ticket.guest_of_diner_id ? ('dining.removeGuestOfDiner' |
            transloco) : ('dining.removeDiner' | transloco)}}</ion-button>
        </ng-container>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</ng-container>

<ng-template #notServiceAppointment>{{'dining.assignDiner' | transloco}}</ng-template>